const config = {
    servUrl: process.env.VUE_APP_SERV_URL,
    servImgUrl: process.env.VUE_APP_SERV_IMG_URL,
    poolData: {
        UserPoolId: process.env.VUE_APP_USER_POOL_ID,
        ClientId: process.env.VUE_APP_CLIENT_ID
    }
}
module.exports = config